'use client';

import { ComponentProps } from 'react';
import { useIntl } from 'react-intl';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import AlgoliaSearchBox from '@alltrails/search/components/AlgoliaSearchBox';
import { getTripPlannerSearchResultHref } from '../../utils/tripPlannerEntryParams';
import styles from './styles/styles.module.scss';

export type SearchBoxProps = Pick<
  ComponentProps<typeof AlgoliaSearchBox>,
  | 'clearOnSelect'
  | 'configs'
  | 'getCurrentLatLng'
  | 'navigateOnSelect'
  | 'onAddressSelect'
  | 'onInputBlur'
  | 'onInputFocus'
  | 'onResultSelect'
  | 'onTripPlannerSelect'
  | 'searchRequestLoading'
  | 'tertiaryElement'
  | 'value'
>;

const SearchBox = (searchProps: SearchBoxProps) => {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();

  const placeholder = intl.formatMessage({ defaultMessage: 'Search' });

  return (
    <div className={styles.searchBox}>
      <AlgoliaSearchBox
        {...searchProps}
        dropdownVariant="enveloping"
        tripPlannerHref={getTripPlannerSearchResultHref(languageRegionCode)}
        placeholder={placeholder}
        searchOrigin="global nav"
        searchTypes="all"
        showTrendingSuggestions
        variant="subtle"
        useTypeAhead
      />
    </div>
  );
};
export default SearchBox;
